var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSitesActive = function SvgSitesActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.175C0 0.973782 0.97378 0 2.175 0H18.325C19.5262 0 20.5 0.973781 20.5 2.175V11.2107C20.5 12.4119 19.5262 13.3857 18.325 13.3857H2.175C0.97378 13.3857 0 12.4119 0 11.2107V2.175ZM2.175 1.5C1.80221 1.5 1.5 1.80221 1.5 2.175V11.2107C1.5 11.5835 1.80221 11.8857 2.175 11.8857H18.325C18.6978 11.8857 19 11.5835 19 11.2107V2.175C19 1.80221 18.6978 1.5 18.325 1.5H2.175Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12.3428V16.5856H9.50002V12.3428H11Z",
    fill: "#082244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22498 16.2928C5.22498 15.8786 5.56076 15.5428 5.97498 15.5428H14.525C14.9392 15.5428 15.275 15.8786 15.275 16.2928C15.275 16.707 14.9392 17.0428 14.525 17.0428H5.97498C5.56076 17.0428 5.22498 16.707 5.22498 16.2928Z",
    fill: "#082244"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99034 3.42988C7.27757 3.72833 7.26848 4.20311 6.97003 4.49034L4.59503 6.77606C4.29658 7.06329 3.82179 7.05419 3.53456 6.75574C3.24733 6.45729 3.25643 5.98251 3.55488 5.69528L5.92988 3.40956C6.22833 3.12233 6.70311 3.13143 6.99034 3.42988Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSitesActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sites-active.c3cc24a6.svg";
export { ForwardRef as ReactComponent };